import * as React from 'react';

import { cn } from '@/lib/utils';

/**
 * Canonical shadcn `<Textarea>` — a plain styled `<textarea>` element. No
 * Radix dependency. Used by the chat composer (and, eventually, anywhere
 * else a multi-line input is needed). The classes mirror `<Input>` so the
 * two land flush against each other in shared layouts.
 *
 * Auto-grow is the responsibility of the consumer (see `Composer.tsx`'s
 * scrollHeight ratchet) — the component itself is purely presentational.
 */
const Textarea = React.forwardRef<HTMLTextAreaElement, React.ComponentProps<'textarea'>>(
  ({ className, ...props }, ref) => {
    return (
      <textarea
        // Neumorphic: same borderless inset-well treatment as <Input>.
        className={cn(
          'flex min-h-[40px] w-full rounded-md border-0 bg-transparent px-4 py-2 text-sm font-semibold shadow-neu-inset ring-offset-background placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring/40 focus-visible:ring-offset-0 disabled:cursor-not-allowed disabled:opacity-50',
          className,
        )}
        ref={ref}
        {...props}
      />
    );
  },
);
Textarea.displayName = 'Textarea';

export { Textarea };
